export const OPENSEA_NFT_URL = process.env.REACT_APP_OPENSEA_NFT_URL;
export const OPENSEA_COLLECTION_URL =
  process.env.REACT_APP_OPENSEA_COLLECTION_URL;
export const ETHERSCAN_URL = process.env.REACT_APP_ETHERSCAN_URL;
